import { all } from 'redux-saga/effects'
import { watchUserManagementSaga } from '../user-management/sagas'
import { watchMainSaga } from './sagas'
import { watchRegisterSaga } from '../register/sagas'
import { watchLocationsSaga } from '../locations/sagas'
import { watchCustomersSaga } from '../customers/sagas'
import { watchDevicesSaga } from '../devices/sagas'
import { watchNetworkDevicesSaga } from '../network-devices/sagas'
import { watchSharingSaga } from '../sharing/sagas'
import { watchReportsSaga } from '../reports/sagas'
import { watchApiKeysSaga } from '../api-keys/sagas'
import { watchDetachedSharingSaga } from '../sharing-detached/sagas'
import { watchSendMailSaga } from './components/common/reports-table/sagas'
import { watchHotSwapSaga } from '../hot-swap/sagas'

export default function* rootSaga() {
    yield all([
        ...watchMainSaga,
        ...watchUserManagementSaga,
        ...watchRegisterSaga,
        ...watchLocationsSaga,
        ...watchCustomersSaga,
        ...watchDevicesSaga,
        ...watchNetworkDevicesSaga,
        ...watchSharingSaga,
        ...watchReportsSaga,
        ...watchApiKeysSaga,
        ...watchDetachedSharingSaga,
        ...watchSendMailSaga,
        ...watchHotSwapSaga
    ])
}
